module.exports = "/_next/static/images/downalt-aca886f64fd6ed8f3d22716eb21346ec.svg";